import { FieldSet } from "../../../../../../components/utils/useFieldSet";
import { JobAppAddressInformationRequest } from "../../../../../api-docs";
import { PublicJobSectionGraph } from "../../../../../graphql.types";
import { AddressInfoFragment } from "../../../../components/self-apply-application-form-fragments/address-info";
import { SelfApplySectionContainer } from "../../../../components/self-apply-section-container";

export const SelfApplyAddressInfoAppSection = (props: {
  fieldSet: FieldSet<JobAppAddressInformationRequest>;
  section: PublicJobSectionGraph;
  isInModal?: boolean;
}) => {
  const { section, fieldSet } = props;
  return (
    <SelfApplySectionContainer.Container
      key={section.id}
      description={section.description}
      title={section.name}
      isRequired={section?.isRequired}
    >
      <SelfApplySectionContainer.Content>
        <div className="pt-8">
          <AddressInfoFragment
            {...fieldSet}
            addressLineOneRequired={section?.isRequired}
            cityRequired={section?.isRequired}
            countryRequired={section?.isRequired}
            stateRequired={section?.isRequired}
            zipCodeRequired={section?.isRequired}
            isInModal={false}
          />
        </div>
      </SelfApplySectionContainer.Content>
    </SelfApplySectionContainer.Container>
  );
};
